import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Grid, Stack, TextField } from '@mui/material';
import React from 'react';

type TrailerTopFiltersProps = {
  trailerSearch: string;
  productSearch: string;
  updatedCount: number;
  onTrailerSearchChange: (value: string) => void;
  onProductSearchChange: (value: string) => void;
  onOpenAdd: () => void;
  onOpenFilter: () => void;
  onSave: () => void;
};

const TrailerTopFilters: React.FC<TrailerTopFiltersProps> = ({
  trailerSearch,
  productSearch,
  updatedCount,
  onTrailerSearchChange,
  onProductSearchChange,
  onOpenAdd,
  onOpenFilter,
  onSave,
}) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        mb: 2,
      }}
    >
      {/* <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', lg: 'center' }}
      >

      </Stack> */}
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
          // sx={{ flex: 1 }}
          >
            <TextField
              size="small"
              label="Search Trailer"
              value={trailerSearch}
              onChange={(e) => onTrailerSearchChange(e.target.value.toUpperCase())}
              fullWidth
            />

            <TextField
              size="small"
              label="Search Product"
              value={productSearch}
              onChange={(e) => onProductSearchChange(e.target.value.toUpperCase())}
              fullWidth
            />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Stack
            direction={{ xs: 'row', sm: 'row' }}
            spacing={1}
            sx={{ minWidth: { lg: 'fit-content' } }}
          >
            <Button variant="outlined" startIcon={<FilterListIcon />} onClick={onOpenFilter} fullWidth>
              Filters
            </Button>

            <Button variant="outlined" startIcon={<AddIcon />} onClick={onOpenAdd} fullWidth>
              Add
            </Button>

            <Button
              fullWidth
              variant="contained"
              size='small'
              startIcon={<SaveIcon />}
              onClick={onSave}
              disabled={updatedCount === 0}
            >
              Save {updatedCount > 0 ? `(${updatedCount})` : ''}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TrailerTopFilters;